import * as type from '../actions/types';

const initialState = {
    logout: [],
    loading: false,
    error: null,
}

export default function logout(state = initialState, action) {
    switch (action.type) {
        case type.POST_LOGOUT_REQUESTED:
            return {
                ...state,
                loading: true,
            }
        case type.POST_LOGOUT_SUCCESS:
            return {
                ...state,
                loading: false,
                logout: [],
                // error:action.errors
            }
        case type.POST_LOGOUT_FAILED:
            return {
                ...state,
                loading: false,
                error: action.message,
            }
        default:
            return state
    }
}